import { observable, action } from 'mobx';
import ApiCaller from '../../utils/api-caller';

class cleanRoomStore {

    // Main Properties

    @observable cleanRoomItems = [];
    @observable cleanRoomPendingOrder = undefined;
    @observable cleanRoomRemark = '';

    // CleanRoom Confirm

    @observable cleanRoomTimeSelected = 'now';
    @observable cleanRoomTimeDeliver = '';
    @observable cleanRoomTimeDeliverDate = '';

    // Initialization

    @action initGetCleanRooms() {
        const that = this;

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CleanRooms.apiGetCleanRooms(languageCode).then((cleanRoomResponses) => {
            if (cleanRoomResponses) {
                that.cleanRoomItems = cleanRoomResponses.items;
            } else {
                that.cleanRoomItems = [];
            }
        });
    }

    @action refreshCleanRooms() {
        const that = this;
        that.cleanRoomItems = [];

        const languageCode = window.localStorage.getItem('lang') || 'en';
        return ApiCaller.CleanRooms.apiGetCleanRooms(languageCode).then((cleanRoomResponses) => {
            if (cleanRoomResponses) {
                that.cleanRoomItems = cleanRoomResponses.items;
            }
        });
    }

    @action initCleanRoomConfirm() {
        this.cleanRoomRemark = '';
        this.cleanRoomTimeSelected = 'now';
        this.cleanRoomTimeDeliver = '';

        this.cleanRoomPendingOrder = this.cleanRoomItems.find(cleanRoomItem => cleanRoomItem.isSelected === true);
        return this.cleanRoomPendingOrder;
    }

    // GET Properties

    @action getCleanRoomPendingOrder() {
        return this.cleanRoomItems.find(cleanRoomItem => cleanRoomItem.isSelected === true);;
    }

    // Set Properties

    @action setCleanRoomIsSelected(taskId, isSelected) {
        this.cleanRoomItems.map(cleanRoomItem => {
            return cleanRoomItem.isSelected = false;
        });

        const cleanRoomItem = this.cleanRoomItems.find(x => x.taskId === taskId);
        cleanRoomItem.isSelected = isSelected;
    }

    @action setCleanRoomRemark(value) {
        this.cleanRoomRemark = value;
    }

    @action setCleanRoomTimeSelected(value) {
        this.cleanRoomTimeSelected = value;
        this.cleanRoomTimeDeliver = '';
    }

    @action setCleanRoomTimeDeliver(value) {
        this.cleanRoomTimeDeliver = value;
        this.cleanRoomTimeSelected = '';
    }

    @action setCleanRoomTimeDeliverDate(value) {
        this.cleanRoomTimeDeliverDate = value;
    }

    // RESET Properties

    @action resetCleanRooms() {
        this.cleanRoomItems = [];
    }
}

export default new cleanRoomStore()